// Configuration for API endpoints
let apiBaseUrl = '';

// Get environment variables
const envApiBaseUrl = import.meta.env.VITE_API_BASE_URL;
const envDevApiUrl = import.meta.env.VITE_DEV_API_URL;

// Determine environment type
const isDevelopment = import.meta.env.DEV;
const isProduction = import.meta.env.PROD;
const baseUrl = window.location.origin;

// Configure the API base URL based on environment
if (isDevelopment) {
  // In development, use the dev API URL if available, or fall back to the relative path
  apiBaseUrl = envDevApiUrl || envApiBaseUrl || '/api';
} else if (isProduction) {
  // In production, use the API base URL from environment, or construct from origin
  apiBaseUrl = envApiBaseUrl || `${baseUrl}/api`;
}

// Export configuration values
export const config = {
  apiBaseUrl,
  chatEndpoint: `${apiBaseUrl}/chat`,
  searchEndpoint: `${apiBaseUrl}/search`,
  appName: import.meta.env.VITE_APP_NAME || 'ObsidianAI+',
};

// For debugging
console.log(`API configuration loaded: ${isDevelopment ? 'Development' : 'Production'} mode`);
console.log(`API Base URL: ${apiBaseUrl}`); 